<template>
    <div class="physicalcarddetail">
        <div class="content">
            <div class="health_card">
                <h3>{{policyInfo.productName}}</h3>
                <ul>
                    <li>体检口令：{{policyInfo.pno}}</li>
                    <li>购买时间：{{policyInfo.issueDate|filterDate}}</li>
                    <li>口令接收手机号：{{policyInfo.mobile|filterNull}}</li>
                    <li>保费：{{policyInfo.totalPremium|filterNull('元')}}</li>
                    <li v-if="policyInfo.income && policyInfo.income>0 && policyInfo.income !='undefined' && policyInfo.income!='null'">
                        {{$route.query.cooperationMode == 1 ? '积分：':'宣传奖励：'}}{{policyInfo.income|filterNull('元')}}
                    </li>
                    <li>状态：{{policyInfo.status}}</li>
                    <li>预约时间：{{policyInfo.reserveDate|filterDate}}</li>
                </ul>
            </div>
            <div class="people_info" v-if="policyInfo.insuredInfo">
                <h3>体检人信息</h3>
                <ul>
                    <li>姓名：{{policyInfo.insuredInfo.name|filterNull}}</li>
                    <li>证件类型：{{policyInfo.insuredInfo.idType|filterStatus(idTypeOptions)}}</li>
                    <li>证件号：{{policyInfo.insuredInfo.idNum|filterNull}}</li>
                    <li>性别：{{policyInfo.insuredInfo.gender|filterNull}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import api from "@/utils/api";
import commonData from '@/utils/commonoptions';
const { idTypeOptions } = commonData;
document.title = '保单详情'
export default {
    data() {
        return {
            idTypeOptions,
            policyInfo: {},
        }
    },
    created() {
        this.fetchData();
    },
    filters:{
        // 处理时间格式
        filterDate(val) {
            if(!val) return '-'
            if(val=='null'||val=='undefined'){
                return '-'
            }
            if(val.indexOf('-') < 0 && val.indexOf('/') < 0) {
                return val;
            }
            let dateArr = [];
            if (val.indexOf('-') > -1) {
                dateArr = val.split('-');
            } else if (val.indexOf('/') > -1) {
                dateArr = val.split('/');
            }
            return `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
        },
        filterStatus:(val,options)=>{
            if(!val){
                return '-'
            }else{
                let name = '-'
                for(let i = 0; i < options.length; i++) {
                    if (options[i].value === val || options[i].text === val) {
                        name = options[i].text;
                        break;
                    }
                }
                return name;
            }
        },
        filterNull:(val, unit='')=>{
            if(!val) return '-'
            if(val=='null'||val=='undefined'){
                return '-'
            }
            return `${val}${unit}`
        },
        filterNumber:(val)=>{
            if(!val){
                return '-'
            } else {
                if(!/^\d+$/.test(val)){
                    return val
                }else{
                    return '保至'+val+'岁'
                }
            }
        },
    },
    methods:{
        fetchData() {
            api.agentRestMedicalDetail({sfid: this.$route.query.proSfid, userId: this.$route.query.userId }).then((res) => {
                // let res = {"returnCode":"0000","returnMsg":"成功","content":{"productName":"医美-北京美中宜和妇儿医院","totalPremium":"2999.00","status":"已预约","reserveDate":"2021-7-17","mobile":"18601180097","issueDate":"2021-7-12","income":"179.94","insuredInfo":{"name":"张梦若","idType":"身份证","idNum":"110104199003101622","gender":"女"},"holderInfo":{"name":"张梦若","idType":"身份证","idNum":"110104199003101622","gender":"女"},"rateInfo":{"recommendRate":null,"nextRate":null,"manageRate":null,"agentRate":"13.00","thirdRate":null,"company":"上海椋鸟健康科技有限公司"},"appointmentMode":"1","bookingPlatformLink":"http://wechatpay.yutai365.com/wechatlink/lnhAppointmentController/toAppointmentPage?param=emhlc2hpeWltZWljaGFucGluZw==","pno":"310165320348"}};
                let { returnCode, returnMsg, content } = res.data;
                if (returnCode !== '0000') {
                    window.$toast(returnMsg);
                    return;
                }
                this.policyInfo = content
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .physicalcarddetail {
        font-size: 12px;
        text-align: left;
        font-family: PingFangSC-Regular, PingFang SC;
        background: #fff;
        min-width: 100vw;
        min-height: 100vh;
        padding: 10px 18px;
        box-sizing: border-box;
        .health_card, 
        .people_info{
            background: #F9F9F9;
            h3 {
                padding: 19px 16px 10px 16px;
                font-size: 15px;
                box-sizing: border-box;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: bold;
                color: #333333;
                line-height: 21px;
            }
            ul {
                li {
                    margin: 0 16px;
                    box-sizing: border-box;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 17px;
                    margin-bottom: 4px;
                }
                li:last-child {
                    margin-bottom: 0;
                    padding-bottom: 15px;
                }
            }
        }
        .health_card {
            border-radius: 7px 7px 0 0;
        }
         .people_info {
            border-radius: 0 0 7px 7px;
        }
        .health_card li:last-child {
            padding-bottom: 15px;
            border-bottom: 1px solid #ececec;
        }
        .people_info h3 {
            padding-top: 15px;
        }
    }
</style>